function Sound_play(sound, state) {
    if (state && sound.readyState >= 2) { // Проверка готовности аудио
        sound.pause();
        sound.currentTime = 0;
        sound.play();
    }
}

export default Sound_play;